module.exports = __webpack_public_path__ + "img/verify6.d500efbb.png";